<template>
  <transition name="tabbar-leave">
    <div v-if="showTabbar" class="v-tabbar">
      <div class="container d-flex w-100">
        <div
          v-for="link in tabbarLinks"
          :key="link.path"
          class="v-tabbar__item"
        >
          <v-link :class="[{ '--active': isActive(link) }]" :to="link.path">
            <v-icon :icon="link.icon" />
            <span class="tabbar__text">{{ link.text }}</span>
          </v-link>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState, mapGetters } from "vuex"

import isPreviewContext from "@/lib/is-platform/is-preview-context"

export default {
  computed: {
    ...mapState("videos", { isVideoFullscreen: "isFullscreen" }),

    ...mapGetters("tabbar", ["shouldShowTabbar", "tabbarLinks"]),

    showTabbar() {
      return isPreviewContext() ? false : this.shouldShowTabbar(this.$route)
    }
  },

  methods: {
    isActive(link) {
      return link.path === "/"
        ? this.$route.path === "/"
        : this.$route.path.startsWith(link.path)
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/styles/variables";
@import "@/assets/styles/mixins";

.v-tabbar {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  min-height: $tabbar--height;
  background: $color-ui--white;
  padding-bottom: env(safe-area-inset-bottom);
  box-shadow: $box-shadow--medium;
  z-index: $toolbar--z-index;

  @include tabbar-background;
}

.v-tabbar__item {
  display: flex;
  flex-direction: column;
  text-align: center;
  position: relative;
  flex-grow: 1;
  flex-basis: 0;
  width: auto;

  &:hover {
    cursor: pointer;
  }

  .v-icon {
    font-size: 1.6rem;
    margin: 0 auto;
  }

  .v-link {
    display: flex;
    height: 56px;
    flex-direction: column;
    justify-content: center;
    text-decoration: none;
    color: $color-ui--grey-50;

    &.--active {
      color: var(--brand-color-hex);

      svg {
        path,
        rect {
          stroke: var(--brand-color-hex);
          fill: var(--brand-color-hex);
        }
      }
    }
  }
}

.tabbar__text {
  font-size: 0.6rem;
  font-weight: 500;
  text-transform: uppercase;
  margin-top: 3px;
}

// Transition
.tabbar-leave-enter-active,
.tabbar-leave-leave-active {
  transition: all 0.4s;
}

.tabbar-leave-enter,
.tabbar-leave-leave-to {
  opacity: 0;
  transform: translateY(57px);
}
</style>
